module.exports = __webpack_public_path__ + "static/media/stories.bad99989.png";